<template>
  <div v-if="factory" class="featured__factory">
    <div class="title">{{factory.business_name}}</div>
    <!-- <div>
      <a :href="'tel:' + factory.phone">{{factory.phone}}</a>
      <a :href="factory.website" target="_blank">{{factory.website}}</a>
    </div> -->
  </div>
</template>

<script>
import {store} from '@/store'
export default {
  name: 'FeatureFactory',
  computed: {
    factory: function() {
      return store.state.featuredfactory
    }
  }
}
</script>

<style scoped lang="less">

.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}

.title {
  font-weight: bold;
  font-size: 1.75em;
  padding-top: 12px;
}

.featured__factory {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  background-color: white;
  padding: 12px 24px 0px 24px;
  box-sizing: border-box;
  a {
    padding-right: 12px;
    margin-right: 6px;
    &:first-child {
      border-right: solid 2px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/mainpage/FeatureFactory.vue